import { Injectable } from '@angular/core';
import { AlarmNotificationTabs } from 'app/shared/enums/alarm-notification-tabs';

@Injectable()
export class AlarmNotificationsHelper {

    constructor(
    ) { }

    public disableTab(tabIndex: number, subscribeOnly: boolean, loadingItemUsers: boolean, notificationId: string, selectedIndex: number) {
        switch (tabIndex) {
            case AlarmNotificationTabs.Locations: 
                return subscribeOnly;
            case AlarmNotificationTabs.NotificationTree:
                return (loadingItemUsers || subscribeOnly || (!notificationId && selectedIndex < tabIndex));
            case AlarmNotificationTabs.Alarm:
            case AlarmNotificationTabs.Validation:
                // Disable if subscribe only OR new add and in earlier tab
                return (
                    subscribeOnly || (!notificationId && selectedIndex < tabIndex)
                );
            case 4:
            default:
                return selectedIndex !== 4;
        }
    }
}
